import React from "react";
import useHome from "./useHome";
import ReactSlider from "../../component/ReactSlider";
import Item from "../../component/Item";
import QuestionOfDay from "./questionOfDay";

const HomePage = () => {
  const { banners, courses, questionOfDaySuccess, closeModal } = useHome();
  return (
    <>
      <div className="flex flex-col gap-5">
        {banners?.length && <ReactSlider images={banners} />}
        <div className="flex justify-between items-center px-5 py-3">
          <h1 className="text-3xl font-bold text-gray-800">Courses</h1>
        </div>
        <div className="grid grid-cols-6 gap-4 p-5">
          {courses?.map((x) => (
            <Item
              key={x?.objectId}
              title={x?.CourseTitle}
              image={x.CourseLogo}
              type={x?.CoursePaidType}
              id={x?.objectId}
            />
          ))}
        </div>
        {/* <div className="flex justify-between items-center px-5 py-3">
          <h1 className="text-3xl font-bold text-gray-800">
            Question of the day!
          </h1>
          <button className="text-blue-500 font-semibold hover:text-blue-600">
            View All
          </button>
        </div> */}
      </div>
      {questionOfDaySuccess && (
        <QuestionOfDay open={questionOfDaySuccess} onClose={closeModal} />
      )}
    </>
  );
};

export default HomePage;
